export * from './bs2-cliente.model';
export * from './bs2-endereco.model';
export * from './bs2-tipo-cliente.enum';

